module.exports = __webpack_public_path__ + "static/media/Portis.a0d89dea.svg";